// extracted by mini-css-extract-plugin
module.exports = {"main-component":"must_main-component__228qB"};